import { getApiErrorMessage } from "shared/utils";
import type { ApiError } from "shared/utils";

const FALLBACK_MESSAGES: Record<number, string> = {
  400: "Invalid email, or this account uses social login.",
  404: "No account found with this email.",
  429: "Too many requests. Please wait before trying again.",
  500: "Something went wrong. Please try again later.",
};

const DEFAULT_MESSAGE = "Failed to send reset link. Please try again.";

export const getForgotPasswordError = (error: ApiError): string | null =>
  getApiErrorMessage(error, FALLBACK_MESSAGES, DEFAULT_MESSAGE);
